export const ARTICLES_PER_PAGE = 10
